import { getBooleanToolPreference, saveBooleanToolPreference, TOOL_PREFERENCE_KEYS } from "./toolPreferenceStorage";

export const saveMathModePreference = async (enabled: boolean) => {
  await saveBooleanToolPreference(TOOL_PREFERENCE_KEYS.mathModeEnabled, enabled);
};

export const getMathModePreference = async (): Promise<boolean> => {
  return getBooleanToolPreference(TOOL_PREFERENCE_KEYS.mathModeEnabled);
};
